<template>
    <div :class="phoneClass || 'dealer-list-container'">
        <div v-if="phoneClass" class="title">
            {{$t("header.gateway")}}
        </div>
        <content-header class="gate-content-header-wrapper">
            <el-button type="primary" class="normal-button" @click="goGatewayEdit()" v-if="!phoneClass && !(user.role === 1)">
                <img src="../../assets/img/btn/icon-add.png">
                <span class="text">{{$t("sideBar.newGateway")}}</span>
            </el-button>
        </content-header>
        <!-- web端 -->
        <div class="dealer-table" v-if="!phoneClass">
            <div class="search-bar">
                <div class="search-left">
                    <div class="status-index" >
                        <div class="status-index">
                            <el-input
                                :placeholder="$t('gatewayPage.eui')"
                                style="width:260px"
                                v-model="searchForm.eui"
                                @change="initPage(),getGatewayList()">
                                <i slot="prefix" class="el-input__icon el-icon-search"></i>
                            </el-input>
                        </div>
                        <div class="status-index">
                            <el-input
                                :placeholder="$t('gatewayPage.name')"
                                style="width:260px"
                                v-model="searchForm.name"
                                @change="initPage(),getGatewayList()">
                                <i slot="prefix" class="el-input__icon el-icon-search"></i>
                            </el-input>
                        </div>
                        <el-button type="primary" @click="initPage(),getGatewayList()">{{$t("devicePage.search")}}</el-button>
                        <el-button @click="initGatewayList()">{{$t("devicePage.reset")}}</el-button>
                    </div>
                </div>
                <div class="search-right">
                </div>
            </div>
            <div class="table-outer">
                <el-table :data="gatewayList" :header-cell-style="{background:'#fafbfc'}" class="normal-table" style="width: 100%">
                    <el-table-column prop="eui" min-width="130px" :label="$t('gatewayPage.eui')" ></el-table-column>
                    <el-table-column prop="name" min-width="120px" :label="$t('gatewayPage.name')"></el-table-column>
                    <el-table-column width="130px" :label="$t('gatewayPage.status')">
                        <div class="table-outer-status" slot-scope="scope">
                            <!-- {{  scope.row.onlineStatus ? scope.row.onlineStatus : '-' }} -->
                            <el-alert
                                v-if="scope.row.onlineStatus === 'ONLINE'"
                                    :title="$t('gatewayPage.online')"
                                    type="success"
                                    style="color:black;background: #88c008"
                                    :closable="false">
                            </el-alert>
                            <el-alert
                                    v-else-if="scope.row.onlineStatus === 'OFFLINE'"
                                    :title="$t('gatewayPage.offline')"
                                    type="info"
                                    style="color:white;background: #99a5aa"
                                    :closable="false">
                            </el-alert>
                        </div>
                    </el-table-column>
                    <!--频段-->
                    <el-table-column  prop="lora_band"  width="160px"  :label="$t('devicePage.lora_band')"></el-table-column>
                    <el-table-column prop="username" min-width="120px" :label="$t('gatewayPage.username')"></el-table-column>
                    <el-table-column prop="useremail" min-width="120px" :label="$t('user.email')"></el-table-column>
                    <el-table-column width="160px" :label="$t('dealerPage.createTime')">
                        <div slot-scope="scope">
                            {{scope.row.create_time | timeFormat(1)}}
                        </div>
                    </el-table-column>
<!--                    <el-table-column  prop="is_enable" :label="$t('dealerPage.operation')" fixed="right" width="100" v-if="user.role === 10?false:true && role">-->
                    <el-table-column  prop="is_enable" :label="$t('dealerPage.operation')" fixed="right" width="100" >
                        <div slot-scope="scope" class='my-table-button'>
                            <img src="../../assets/img/icon/authority-set.png" @click="editGateway(scope.row)">
                            <img src="../../assets/img/icon/authority-del.png"  v-if="user.role === 1 || user.role === 100" @click="deleteGateway(scope.row)" alt="">
                            <!-- <img src="../../assets/img/icon/authority-del.png"   @click="deleteGateway(scope.row)" alt=""> -->
<!--                            <img src="../../assets/img/icon/authority-off.png" v-else  @click="deleteAgent(scope.row)">-->
                            <!--is_enable    返回的是0  启用   1 禁用 -->
                        </div>
                    </el-table-column>
                </el-table>
            </div>
            <div class="pagination" style="text-align:right;padding:20px;">
                <el-pagination
                    @current-change="pageChange"
                    :current-page="currentPage"
                    :page-size="pageSize"
                    layout="total, prev, pager, next"
                    :total="total"
                    background>
                </el-pagination>
            </div>
        </div>
        <!-- 移动端 -->
        <div v-else class="phone-log-table-list">
            <div class="search-bar">
                <div class="search-left">
                    <div class="inputs">
                        <div class="status-index first">
                            <el-input
                                :placeholder="$t('gatewayPage.eui')"
                                style="width:260px"
                                v-model="searchForm.eui"
                                @change="initPage(),getGatewayList()">
                                <i slot="prefix" class="el-input__icon el-icon-search"></i>
                            </el-input>
                        </div>
                        <div class="status-index">
                            <el-input
                                :placeholder="$t('gatewayPage.name')"
                                style="width:260px"
                                v-model="searchForm.name"
                                @change="initPage(),getGatewayList()">
                                <i slot="prefix" class="el-input__icon el-icon-search"></i>
                            </el-input>
                        </div>
                    </div>
                    <div class="btns">
                        <el-button type="primary" @click="initPage(),getGatewayList()">{{$t("devicePage.search")}}</el-button>
                        <el-button @click="initGatewayList()">{{$t("devicePage.reset")}}</el-button>
                    </div>
                </div>
                <div class="search-right">
                </div>
            </div>
            <div class="phone-log-table-item" v-for="(item, index) in gatewayList" :key="index">
                <div class="top item">
                    <div class="left">{{$t('gatewayPage.eui')}}</div>
                    <div class="right">{{item.eui}}</div>
                </div>
                <div class="middle item">
                    <div class="left">{{$t('gatewayPage.name')}}</div>
                    <div class="right">{{item.name}}</div>
                </div>
                <div class="bottom item">
                    <div class="left">{{$t('gatewayPage.createTime')}}</div>
                    <div class="right">{{item.create_time | timeFormat(1)}}</div>
                </div>
                <div class="bottom item">
                    <div class="left">{{$t('gatewayPage.update_time')}}</div>
                    <div class="right">{{item.update_time | timeFormat(1)}}</div>
                </div>
                <div class="bottom item">
                    <div class="left">{{$t('gatewayPage.status')}}</div>
                    <div class="right status">
                        
                            <!-- {{  scope.row.onlineStatus ? scope.row.onlineStatus : '-' }} -->
                        <el-alert
                            v-if="item.onlineStatus === 'ONLINE'"
                            :title="$t('gatewayPage.online')"
                            type="success"
                            style="color:black;background: #88c008"
                            :closable="false">
                        </el-alert>
                        <el-alert
                            v-else-if="item.onlineStatus === 'OFFLINE'"
                            :title="$t('gatewayPage.offline')"
                            type="info"
                            style="color:white;background: #99a5aa"
                            :closable="false">
                        </el-alert>
                    </div>
                </div>
                <div class="btns">
                    <el-button type="primary" plain @click.stop="editGateway(item)">编辑</el-button>
                    <el-button type="danger" plain v-if="user.role === 1 || user.role === 100" @click.stop="deleteGateway(item)">删除</el-button>
                    <!-- <el-button type="danger" plain  @click.stop="deleteGateway(item)">删除</el-button>                     -->
                </div>
            </div>
        </div>
    </div>
</template>


<script>
import Core from "core/core";
import {refresh} from "core/winSize"
import contentHeader from '../../components/content-header'
// import axios from 'axios';
import { get } from 'lodash';
export default {
    data() {
        return {
            phoneClass: '',
            user: Core.Data.getUser(),
            gatewayList: [],
            currentPage: 1,
            pageSize: 10,
            total: 0,
            searchForm: {
                eui: '',
                name: '',
            },
            deviceStatusList: [
                {label: '全部',value: 0}
            ],
            loadingL: '',
            fileUrl: Core.Const.NET.IMPORT_FILE + 'import-agent',
            regionData: [],
            pcc: [],
            regionProps: {
                value: 'name',
                label: 'name'
            },
            province: '',
            city: '',
            role: false,
            handleList: 1,
        };
    },
    components: {
        contentHeader
    },
    created(){
        refresh(this,'phoneClass-gateway-list-container');
        window.onresize = function(){
		    setTimeout(function(){
			    refresh(this,'phoneClass-gateway-list-container');
		    },10)
	    };
    },
    mounted() {
        this.getGatewayList();
    },
    computed: {
    },
    methods: {
        initGatewayList() {
            this.searchForm.name = ''
            this.searchForm.eui = ''
            this.initPage()
            this.getGatewayList()
        },
        getGatewayList() {
            console.log("getGatewayList")
            Core.Api.Gateway.list(this.searchForm.eui,this.searchForm.name,this.currentPage,this.pageSize).then(res => {
                // console.log(res,"###");
                this.gatewayList = res.list;
                this.gatewayList.forEach(item=>{
                    if(item.user) {
                        item.username = item.user.username || "-"
                        item.useremail = item.user.email || "-"
                    } else {
                        item.username = "-";
                        item.useremail = "-";
                    }
                    item.onlineStatus = get(item, 'status.data.gateway.status', null);
                })
                this.total = res.count;

            })
        },
        pageChange(val) {
            this.currentPage = val;
            this.getGatewayList();
        },
        deleteGateway(row){
            // console.log(row.id)
            this.$confirm('您确定要删除该设备吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                customClass: this.phoneClass?'message-box':''
            }).then(() => {
                Core.Api.Gateway.delete(row.id).then((res)=>{
                    this.$message({
                        type: 'success',
                        message: '删除成功!',
                        customClass: this.phoneClass?'my-message':''
                    });
                    this.getGatewayList();
                })
            })
        },
        editGateway(row) {
            if(!row.id) {
                return
            }
            this.$router.push(`/device/gateway/add?gateway_id=${row.id}`)
        },
        goGatewayEdit() {
            this.$router.push('/device/gateway/add')
        },

        initPage(){
            this.currentPage = 1
        },

    },


};
</script>

<style scoped lang="scss">
@import '../../assets/style/mixin.scss';
.dealer-list-container {
    background-color: #E5EBEF;
    height: 100%;
    .dealer-table {
        margin: 30px 40px;
        background-color: #FFFFFF;
        .search-bar {
            @include flex-sb;
            padding: 20px;
            .status-index {
                margin-right: 12px;
                &:last-child {
                    margin-right: 0;
                }
            }
        }
        .table-outer {
            padding: 0 20px;
        }
    }
    .normal-button {
        background-color: transparent;
        border-color: #FFFFFF;
        img {
            width: 13px;
            height: 13px;
            vertical-align: middle;
        }
        .text {
            font-size: 14px;
            color: #FFFFFF;
            vertical-align: middle;
            margin-left: 8px;
            line-height: 20px;
        }
    }
}
</style>

<style lang="scss" scoped>
.dealer-list-container {
    .table-outer {
        .cell {
            white-space:nowrap;
            overflow:hidden; //超出的文本隐藏
            text-overflow:ellipsis; //溢出用省略号显示
        }
        .cell:hover {
            /*background: #e2e2e2;*/
            white-space: normal;
            overflow: visible; //超出的文本隐藏
            position: relative;
            z-index: 10000;
            text-overflow:clip;
            /*background: #f6f7fb;*/
        }
        /*状态样式*/
        .table-outer-status {
            >div{
                display: inline-block;
                white-space:nowrap !important;
            }
        }
        .el-alert {
            margin: 0;
            padding: 0;
            min-width: 48px;
            height: 26px;
            font-size: 10px !important;
            .el-alert__content{
                margin: 0 auto;
                padding: 0;
                .el-alert__title {
                    margin: 0 auto;
                    font-size: 10px !important;

                }
            }
        }
        .cell {
            white-space:nowrap;
            overflow:hidden; //超出的文本隐藏
            text-overflow:ellipsis; //溢出用省略号显示
        }
        .cell:hover {
            white-space: normal;
            overflow: visible; //超出的文本隐藏
            position: relative;
            z-index: 10000;
            text-overflow:clip;
        }
    }
}
.my-table-button img{
    cursor: pointer;
}
.status-index {
    display: inline-block;
    /*vertical-align: middle;*/
    .top-title {
        border: 1px solid rgba(7, 17, 27, .1);
        border-right: none;
        border-radius: 4px 0 0 4px;
        min-width: 60px;
        height: 32px;
        background-color: #F5F7F9;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        font-size: 12px;
        color: #80868B;
        cursor: pointer;
    }
    .el-select {
        width: 243px;
        .el-input__inner {
            height: 32px;
            /*width: 243px;*/
            border-top-left-radius: 0;
            border-bottom-left-radius: 0;
        }
    }
    .el-input__inner {
        height: 32px;
        border-top-left-radius: 5px;
        border-bottom-left-radius: 5px;
    }
    .input-index {
        position: relative;
        img {
            position: absolute;
            width: 20px;
            height: 20px;
            top: 8px;
            right: 8px;
            cursor: pointer;
        }
        .el-input__inner {
            width: 300px;
            height: 34px;
            box-sizing: border-box;
            border-radius: 3px;
            padding-right: 30px;
        }
    }
    .el-cascader {
        .el-input__inner {

            border-top-left-radius: 0;
            border-bottom-left-radius: 0;
        }
    }
}
.phoneClass-content-container {
    background: rgb(247, 249, 250);
}
.phoneClass-gateway-list-container {
    .title {
        display: flex;
        align-items: center;
        padding-left: 15px;
        min-height: 46px;
        font-weight: 600;
        color: #353C41;
        font-size: 20px;
        background-color: #fff;
    }
    .phone-log-table-list {
        padding: 0px 0 50px 0px;
        .search-bar {
            padding: 0 10px;
            .search-left {
                display: flex;
                flex-direction: column;
                .inputs {
                    width: 100%;
                    margin-bottom: 10px;
                    .el-input {
                        width: 100% !important;
                    }
                    .el-input__inner {
                        width: 100%;
                    }
                    .first {
                        margin-bottom: 10px;
                    }
                }
            }
            
        }
        .phone-log-table-item {
            background-color: #fff;
            margin-bottom: 10px;
            padding: 12px 17px;
            .item {
                display: flex;
                justify-content: space-between;
                font-size: 16px;
                font-weight: 400;
                line-height: 22px;
                .left {
                    color: #878E98;
                }
                .right {
                    color: #363D42;
                }
                
            }
            .btns {
                margin-top: 20px;
                text-align: right;
            }
            .el-alert {
                margin: 0;
                padding: 0;
                min-width: 48px;
                height: 22px;
                font-size: 10px !important;
                text-align: center;
                .el-alert__content{
                    margin: 0 auto;
                    padding: 0;
                    .el-alert__title {
                        margin: 0 auto;
                        font-size: 10px !important;

                    }
                }
            }
        }
    }
    .phoneClass-content-header-wrapper {
        position: relative;
        background-color: #0A3D95;
        margin-bottom: 10px;
        display: flex;
        align-items: center;
        margin-bottom: 0;
        padding: 8px 0;
        .header-right {
            width: 99%;
            position: absolute;
            right: 3px;
            bottom: 3px;
            display: flex;
            justify-content: space-between;
            .el-button {
                margin: 0 0 !important;
                padding: 5px !important;
                width: 90px;
                border-color: white;
                background-color: #0A3D95;
                img {
                    width: 12px;
                }
            }
            >div {
                margin: 0 !important;
                >div {
                    .el-button {
                        padding: 5px 0 !important;
                        width: 70px;
                        margin: 0 3px !important;
                    }
                }
            }
            .el-button:nth-child(3) {
                width: 101px;
            }
        }
        // .title_tab {
        //     padding: 6px;
        //     vertical-align: middle;
        //     font-size: 16px;
        //     color: #fff;
        //     font-weight: 500;
        //     border-radius: 2px;
        // }
        // .title_tab_pitch {
        //     padding: 6px;
        //     vertical-align: middle;
        //     font-size: 16px;
        //     color: #0A3D95;
        //     font-weight: 500;
        //     background: #fff;
        //     border-radius: 2px;
        // }
    }
    .search-bar {
        padding-left: 10px;
        .search-left {
            margin: 15px 0;
        }
        .search-right {
            margin-bottom: 15px;
        }
    }

    .pagination {
        padding: 20px 0 !important;
        text-align: center !important;
        .el-pagination {
            padding: 0;
            button {
                width: 20px;
                min-width: 0;
                height: 30px;
            }
            .el-pager {
                .number {
                    margin: 0 3px !important;
                    padding: 0 !important;
                    min-width: 0px;
                    width: 20px !important;
                    height: 30px !important;
                }
                .el-icon-more {

                    margin: 0 3px !important;
                    padding: 0 !important;
                    min-width: 0px;
                    width: 20px !important;
                    height: 30px !important;
                }
            }
        }
    }
}
</style>
<style lang="scss">
.my-message {
    width: 70% !important;
}
.message-box {
    width: 90% !important;
}
</style>
